import { Icon } from "../../../../elements/Icon";

import { styles } from "./SocialMediaLinks.style";

const facebookIcon = require("./images/facebook-square-blue.svg");
const twitterIcon = require("./images/twitter-square-blue.svg");
const linkedinIcon = require("./images/linkedin-square-blue.svg");

export interface SocialMediaLinksProps {
  facebook?: string;
  twitter?: string;
  linkedin?: string;
}

export const SocialMediaLinks = (props: SocialMediaLinksProps) => {
  const { facebook, twitter, linkedin } = props;
  return (
    <div className={styles.socialMediaWrapper()}>
      {facebook && (
        <a href={facebook} aria-label="Facebook" target="_blank" rel="noreferrer">
          <Icon icon={facebookIcon} />
        </a>
      )}
      {twitter && (
        <a href={twitter} aria-label="Twitter" target="_blank" rel="noreferrer">
          <Icon icon={twitterIcon} />
        </a>
      )}

      {linkedin && (
        <a href={linkedin} aria-label="Linkedin" target="_blank" rel="noreferrer">
          <Icon icon={linkedinIcon} />
        </a>
      )}
    </div>
  );
};
